import EventEmitter from "./EventEmitter.js"

export default class Sizes extends EventEmitter {
    constructor() {
        super()

        // Setup
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // wieport sizes check
        this.mediaQuerySquare = window.matchMedia('(min-aspect-ratio: 1/1)');
        this.mediaQuerySquare.addEventListener('change', _event => {
            if (_event.matches) {
                window.setTimeout(() => {
                    this.width = window.innerWidth
                    this.height = window.innerHeight
                    this.trigger('resize')
                }, 50)
            } else {
                window.setTimeout(() => {
                    this.width = window.innerWidth
                    this.height = window.innerHeight
                    this.trigger('resize')
                }, 50)
            }
        })



        // Resize event
        window.addEventListener('resize', () => {
            this.width = window.innerWidth
            this.height = window.innerHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 2)

            this.trigger('resize')
        })
    }
}